import { DeleteData } from 'domain/entity/deleteData';
import { Result } from 'domain/types';
import DeleteDashboardAnalysisClient from 'use-case/analysis/deleteDashboardAnalysis/deleteDashboardAnalysisClient';
import DeleteDashboardAnalysisCriteria from 'use-case/analysis/deleteDashboardAnalysis/deleteDashboardAnalysisCriteria';

export type DeleteDashboardAnalysisResult = Result<DeleteData>;
export type DeleteDashboardAnalysis = (criteria: DeleteDashboardAnalysisCriteria) => Promise<DeleteDashboardAnalysisResult>;

export default (deleteDashboardAnalysisClient: DeleteDashboardAnalysisClient): DeleteDashboardAnalysis => (
    criteria: DeleteDashboardAnalysisCriteria
): Promise<DeleteDashboardAnalysisResult> => deleteDashboardAnalysisClient(criteria);
